<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <a class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          href="#" data-bs-toggle="modal" data-bs-target="#genererFactureModal">
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Générer une facture
        </a>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher une facture" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Marché
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Type
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Mois
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                ANNEE
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                DATE
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                ACTION
              </th>

            </tr>
          </thead>
          <tbody>
            <tr v-for="(re, index) in factures" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span class="ml-2" v-for="(m, index2) in (re?.lesMarches).split(',')"
                  :key="index2">
                  {{ m }}
                </span>
                {{ re.marche ? ((re.marche.libelle.length > 20) ? re.marche.libelle.substring(0, 20) + '...' :
                  re.marche.libelle) : '' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span class="badge bg-secondary text-white" v-for="(r, index2) in (re?.lesTypes).split(',')"
                  :key="index2">
                  {{ r }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ re.mois }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ re.annee }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_date(re.createdAt) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary pe-0">
                <div class="dropdown">
                  <button class="btn btn-sm btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a @click="telecharger(re)" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-send lh-1 me-8 position-relative top-1"></i> Télécharger factures
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <GenererFactureModal @close="recharger" />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';
import ApiService from '@/services/ApiService';
import { Facture } from '@/models/Facture';
import GenererFactureModal from './GenererFactureModal.vue';
import { success, error, format_date, fusionPdf, getUrlApiForFiles } from '@/utils/utils';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";

export default defineComponent({
  name: "GenererFacture",
  components: {
    GenererFactureModal,
    PaginationComponent
  },
  setup: () => {

    const factures = ref<Array<any>>([]);

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllFactures(page_, limit_);
      } catch (error) {
        //
      }
    };
    function rechercher() {
      getAllFactures(page.value, limit.value, searchTerm.value);
    }
    // END PAGINATE

    const recharger = () => {
      getAllFactures();
    };

    const telecharger = async (id: any) => {
      try {
        const response = await ApiService.post("/getLesFactureGenere", { id:id.id });
        console.log("Reponse ==> ", response.status);
        if (response.status == 200) {
          await openNewWindow(id);
        } else {
          error("Erreur lors du téléchargement de la facture");
        }
      } catch (err) {
        console.error("Erreur lors de la fusion des PDF :", err)
      }


    }

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    function openNewWindow(data: any, dossier = "Fusion") {
      openAndPrint(getUrlApiForFiles(dossier, "FusionFactures"+data.id + ".pdf"));
    }

    function getAllFactures(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/all/genereFactures?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          console.log(data);
          factures.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
        });

    }

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }


    onMounted(() => {
      getAllFactures();
    });

    return {
      openNewWindow,
      factures,
      recharger,
      format_date,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      searchTerm,
      rechercher,
      checkPermission,
      telecharger
    };

  },
});
</script>

<style src="@vueform/multiselect/themes/default.css"></style>